import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { OperandosService, Rates } from '@app/core/services/api';
import { Product } from '@app/core/services/api/model/product.model';
import { ModalService } from '@app/core/services/modal/modal.service';
import { ShoppingCartService } from '@app/core/services/shopping-cart/shopping-cart.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCTOR } from '../utils/commonMethods';

export interface ILabelLink {
  label: string; // Montañismo
  link: string; // /risks/montanimos
}

@Component({
  selector: 'app-tarifas-table',
  templateUrl: './tarifas-table.component.html',
  styleUrls: ['./tarifas-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TarifasTableComponent implements OnInit, AfterViewInit {
  @ViewChild('tableEvent') tableEvent: any;
  @Input() indexBlink: number;
  @Input() title: string;
  @Input() resultTable = false;
  @Input() calcDisclaimer = false;
  @Output() calc: EventEmitter<boolean> = new EventEmitter();
  displayedColumnsGroup: string[] = [];
  displayedColumnsMock: string[] = [];
  numRowFooter = 0;
  dataSourceMock: any[] = [];
  minWidthRow = 0;
  role = '';
  _dataSource: Rates;
  operands: string[];
  public newData: any[] = [];
  public dataCard: Product = new Product({});
  literals = {
    es: 'calculador metabólico',
    en: 'metabolic calculator',
    fr: 'calculateur métabolique',
    pt: 'calculador metabólico',
    nl: 'metabolische calculator'
  };
  currentLanguage: string;
  labelCoverages: string[] = [];

  constructor(
    public cartService: ShoppingCartService,
    private translateSrv: TranslateService,
    private operandosSrv: OperandosService,
    private authSrv: AuthenticationService,
    private router: Router,
    private modalSrv: ModalService,
    private sanitazer: DomSanitizer
  ) {}
  @Input() set dataSource(value) {
    this._dataSource = value;
    this.numRowFooter = 0;
    this.initTable();
  }

  ngOnInit(): void {
    this.initTable();
  }

  initTable() {
    this.currentLanguage = this.translateSrv.currentLang;
    this.operandosSrv.operandosGet().subscribe({
      next: (data) => {
        this.operands = [...data];
      },
      error: (error) => console.log(error)
    });
    this.role = this.authSrv.getRoles()[0];
    this.displayedColumnsMock = [];
    this.newData = [];
    this.labelCoverages = [];

    this.labelCoverages = [...this._dataSource.headerValues];

    this.displayedColumnsMock = this.displayedColumnsMock.concat(this.labelCoverages);
    // add col actions, esto hay que quitarlo cuando este listo el servicio
    this.displayedColumnsMock.push('actions');

    // duplicate columns to groups
    this.displayedColumnsGroup = this.displayedColumnsMock.map((value: string) => 'group_' + value);

    this.dataSourceMock = this.prepareData(this._dataSource.values);
  }

  addEvents() {
    if (this.tableEvent?._elementRef?.nativeElement) {
      this.tableEvent?._elementRef?.nativeElement.querySelectorAll('[\\(click\\)]').forEach((element) => {
        let click = element.getAttribute('(click)');
        if (click.indexOf("redirectRate('") !== -1) {
          click = click.replace("redirectRate('", '').replace("')", '');
        }
        element.addEventListener('click', () => {
          this.redirectRate(click);
        });
      });
    }
  }

  linkedRisk(element: any) {
    return element && typeof element === 'object' && element.changingThisBreaksApplicationSecurity.includes('(click)="');
  }

  ngAfterViewInit() {
    if (this.indexBlink > -1) {
      const row = document.getElementsByClassName('mat-row')[this.indexBlink];
      row.className += ' blink';
      row.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    this.addEvents();
  }

  isParent(index, item): boolean {
    return item?.isParent;
  }

  isDoctorRole() {
    return this.authSrv.checkRolUser(DOCTOR);
  }

  sanitizerHtml(value: string) {
    const parser = new DOMParser();
    const document = parser.parseFromString(value, 'text/html');
    return this.sanitazer.bypassSecurityTrustHtml(document.body.outerHTML);
  }

  checkAndTransformLinkData(data: any[]) {
    data.forEach((item, index) => {
      if (typeof item === 'object' && item?.changingThisBreaksApplicationSecurity === undefined) {
        if (item && item.label) {
          let label = item.label;
          if (typeof item.label === 'object') {
            label = item.label[this.translateSrv.currentLang];
          }
          const html = `<a (click)="redirectRate('${item.link}')" >${label}</a>`;
          data[index] = this.sanitizerHtml(html);
        } else {
          if (item && item[this.translateSrv.currentLang]) {
            data[index] = item[this.translateSrv.currentLang];
          } else {
            data[index] = '';
          }
        }
      }
    });
  }

  redirectRate(item) {
    this.calc.emit(true);
    this.router.navigateByUrl('/' + item);
  }

  prepareData(data: any[]) {
    for (const v of data) {
      if (v.children?.length > 0) {
        if (v.level === 1) {
          v.values[this._dataSource.stickyColsStart - 1] = `<div>${this.translateSrv.instant(v.values[this._dataSource.stickyColsStart - 1])}</div>`;
          this.checkAndTransformLinkData(v.values);
          this.newData.push({
            isParent: true,
            values: v,
            level: v.level
          });
        } else {
          v.values[this._dataSource.stickyColsStart - 1] = `<div>${this.translateSrv.instant(v.values[this._dataSource.stickyColsStart - 1])}</div>`;
          this.checkAndTransformLinkData(v.values);
          this.newData.push({
            values: v.values.concat(v.id),
            level: v.level
          });
          // añadimos al final el id para la accion del carrito hay que quitar esto cuando este el servicio listo. .concat('cart_'+v.id)
        }

        this.prepareData(v.children);
      } else {
        let copyValues = [...v.values];
        copyValues[this._dataSource.stickyColsStart - 1] = `<div>${this.translateSrv.instant(
          copyValues[this._dataSource.stickyColsStart - 1]
        )}</div>`;
        this.checkAndTransformLinkData(copyValues);
        if (v.id === 'NO_CART') {
          this.newData.push({
            values: copyValues.concat(v.id),
            level: v.level
          });
        } else {
          copyValues = copyValues.map((value: string, index: number) => (index > 1 && value === '' ? '-' : value));
          this.newData.push({
            values: copyValues.concat('cart_' + v.id),
            level: v.level
          });
        }
        // añadimos al final el id para la accion del carrito hay que quitar esto cuando este el servicio listo. .concat('cart_'+v.id)
      }
    }
    return this.newData;
  }

  isInCart(id: string): boolean {
    return this.cartService.isInCart(id);
  }

  isToCalculate(element: any) {
    const arr = Array.isArray(element) ? element : element?.values;
    if (!arr) {
      return false;
    }

    return arr.some((item) => {
      if (typeof item !== 'string') {
        return false;
      }
      if (item.startsWith('<div class=')) {
        return false;
      } else {
        if (this.resultTable) {
          return false;
        } else {
          return this.includesLiteral(item, this.currentLanguage.toLowerCase());
        }
      }
    });
  }

  normalizeText(text: string): string {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  includesLiteral(item: string, lang: string): boolean {
    const literal = this.literals[lang];
    return this.normalizeText(item).includes(this.normalizeText(literal));
  }

  openCalculator(element: any) {
    const arr = Array.isArray(element) ? element : element?.values;
    if (!arr) {
      this.router.navigate(['metabolic-calculator']);
    } else {
      if (arr.includes('mel')) {
        this.router.navigate(['melanoma-calculator']);
      } else if (arr.includes('met')) {
        this.router.navigate(['metabolic-calculator']);
      } else if (arr.includes('bc')) {
        this.router.navigate(['breast-cancer-calculator']);
      } else {
        this.router.navigate(['metabolic-calculator']);
      }
    }
    this.calc.emit(true);
  }

  removeToCart(id: string): void {
    const p = new Product({});
    p.id = id;
    this.cartService.removeItem(p);
  }
  addToCart(id: string): void {
    if (!this.calcDisclaimer) {
      this.dataCard.id = id;
      this.dataCard = this.getTitleDesc(this.dataCard.id);
      this.cartService.addItem(this.dataCard);
    } else {
      // console.log('Mostramos modal');
      this.modalSrv.openModalInfo('', 'MODAL-WARNING.MODAL-INFO.METCAL-DISCLAIMER');
    }
  }

  disabledActions() {
    return false;
  }

  getTitleDescById(id: string, data: any[], dataCard: any) {
    for (const m of data) {
      if (id?.includes('CALC_MEL')) {
        dataCard.description = this.title;
      } else {
        if (id?.includes(m.id)) {
          if (dataCard.parentId === id) {
            dataCard.name = this.title ? this.title : id.split('_')[0];
            break;
          } else {
            dataCard.description = dataCard?.description
              ? this.removeHtml(m.values[this._dataSource.stickyColsStart - 1]) + ' > ' + dataCard.description
              : this.removeHtml(m.values[this._dataSource.stickyColsStart - 1]);
            this.getTitleDescById(dataCard.parentId, this._dataSource['values'], dataCard);
          }
        } else if (m.children?.length > 0) {
          dataCard.parentId = m.id;
          this.getTitleDescById(id, m.children, dataCard);
        }
      }
    }
    return null;
  }

  removeHtml(html: string) {
    const firstRegex = new RegExp(/<div class="cps-\d">/g);
    const secongRegex = new RegExp(/<\/div>/g);
    return html.replace(firstRegex, '').replace(secongRegex, '');
  }

  getTitleDesc(id: string): Product {
    const dataCard = {
      id,
      parentId: '',
      description: '',
      name: ''
    };
    this.getTitleDescById(id, this._dataSource['values'], dataCard);
    delete dataCard.parentId;
    return new Product(dataCard);
  }
}
